import {
	ADD_COMMENTS_LIKES_REQUEST,
	ADD_COMMENTS_LIKES_SUCCESS,
	ADD_COMMENTS_LIKES_FAILURE
} from "../../constants";

const initialState = {
	commentlikes: null,
	loading: false,
	error: null,
}

const addWallPostCommentLikes = (state = initialState, action) => {
	switch (action.type) {
		case ADD_COMMENTS_LIKES_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};

		case ADD_COMMENTS_LIKES_SUCCESS:
			return {
				...state,
				loading: false,
				likes: action.payload,
			};

		case ADD_COMMENTS_LIKES_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				commentlikes: null,
			};

		default:
			return state;
	}
}

export default addWallPostCommentLikes;
